import React from 'react';
import styled from 'styled-components';
import Footer from '../components/Footer'; // Adjust the import path as per your project structure

const ContactWrapper = styled.section`
  padding: 90px;
  background-color: #828282;
  color: #000000;
  text-align: left;
  margin-top: -10px;

  h1 {
    margin-left: 180px;
    font-size: 2.5rem;

    @media (max-width: 1024px) {
      margin-left: 100px;
      font-size: 2.2rem;
    }

    @media (max-width: 768px) {
      margin-left: 50px;
      font-size: 2rem;
      text-align: center;
    }

    @media (max-width: 480px) {
      margin-left: 0;
      font-size: 1.8rem;
    }
  }

  p {
    margin-left: 180px;
    font-size: 1.2rem;
    line-height: 1.6;

    @media (max-width: 1024px) {
      margin-left: 100px;
      font-size: 1.1rem;
    }

    @media (max-width: 768px) {
      margin-left: 50px;
      font-size: 1rem;
      text-align: center;
    }

    @media (max-width: 480px) {
      margin-left: 0;
      font-size: 0.9rem;
    }
  }

  @media (max-width: 1024px) {
    padding: 60px 30px;
  }

  @media (max-width: 768px) {
    padding: 40px 20px;
  }

  @media (max-width: 480px) {
    padding: 20px 10px;
  }
`;

const SocialMediaContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 30px;
  flex-wrap: wrap;

  @media (max-width: 1024px) {
    gap: 18px;
  }

  @media (max-width: 768px) {
    gap: 15px;
  }

  @media (max-width: 480px) {
    gap: 10px;
  }
`;

const SocialButton = styled.a`
  display: inline-block;
  padding: 10px 20px;
  background-color: #828282;
  color: #000000;
  text-decoration: none;
  font-weight: bold;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  font-size: 1rem;

  &:hover {
    background-color: #f5c32c;
  }

  @media (max-width: 1024px) {
    padding: 9px 18px;
    font-size: 0.95rem;
  }

  @media (max-width: 768px) {
    padding: 8px 16px;
    font-size: 0.9rem;
  }

  @media (max-width: 480px) {
    padding: 6px 12px;
    font-size: 0.85rem;
  }
`;

const ContactPage = () => (
  <>
    <ContactWrapper>
      <h1>CONNECT</h1>
      <p>
        I'd love to hear from you! Connect with me through any of the platforms below:
      </p>
      <SocialMediaContainer>
        {/* Email Button */}
        <SocialButton href="mailto:adityssh.in@gmail.com" aria-label="Send Email">
          Email
        </SocialButton>

        {/* LinkedIn Button */}
        <SocialButton
          href="https://www.linkedin.com/in/aditirshinde/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Visit LinkedIn Profile"
        >
          LinkedIn
        </SocialButton>

        {/* GitHub Button */}
        <SocialButton
          href="https://github.com/Aditys018"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Visit GitHub Profile"
        >
          GitHub
        </SocialButton>

        {/* Twitter Button */}
        <SocialButton
          href="https://x.com/AbstrctDaTyp"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Visit Twitter Profile"
        >
          Twitter
        </SocialButton>
      </SocialMediaContainer>
    </ContactWrapper>
    <Footer />
  </>
);

export default ContactPage;